import { ExternalUserEQueriesColumns } from '../../e-queries/e-queries-columns/external-user-e-queries-columns';
import { CovanceGridColumn } from '../../covance-ag-grid';
import { ExternalUserEQuery } from '../../e-queries/models/external-user-e-query';
import { SponsorStudy } from '../../sponsor-dashboard/sponsor-study';
import { GridColumns } from '../../shared/grid-columns';
import { EQueriesColumns } from '../../e-queries/e-queries-columns';
import { UrlBuilder } from '../../core';
import { Injectable } from '@angular/core';
import { SubjectTitleRenderer } from '../../renderer/subject-title-renderer';

@Injectable()
export class SponsorEQueryColumns {
    constructor(
        private readonly gridColumns: GridColumns,
        private readonly eQueriesColumns: EQueriesColumns,
        private readonly urlBuilder: UrlBuilder,
        private readonly externalUserEQueriesColumns: ExternalUserEQueriesColumns
    ) {
    }

    public getAwaitingColumns(siteId: number, selectedStudy: SponsorStudy): CovanceGridColumn[] {
        return  [
            this.eQueriesColumns.eQueryIdColumn<ExternalUserEQuery>(
                params =>
                    this.urlBuilder
                        .esa()
                        .globalPopup()
                        .sponsorEQueryDetails(params.data.eQueryId)
                        .url()),
            this.externalUserEQueriesColumns.status,
            this.eQueriesColumns.ageColumn(),
            this.gridColumns.subjectColumn<ExternalUserEQuery>(
                params =>
                    this.urlBuilder
                        .esa()
                        .sponsor()
                        .study(selectedStudy)
                        .subjects(params.data.zcSubjectId)
                        .url(),
                data => SubjectTitleRenderer.renderSubjectNumberOrScreening(data)),
            this.gridColumns.accessionNumberColumn<ExternalUserEQuery>(
                params =>
                    this.urlBuilder
                        .esa()
                        .sponsor()
                        .study(selectedStudy)
                        .testResults(siteId)
                        .standardTestResults()
                        .url(),
                data => [data.accessionNumber],
            ),
            this.externalUserEQueriesColumns.visitCollectionDate,
            this.externalUserEQueriesColumns.visitName,
            this.externalUserEQueriesColumns.protocolVisitCode,
            
        ];
    }

    public getSubmittedColumns(siteId: number, selectedStudy: SponsorStudy): CovanceGridColumn[] {
        return [
            this.eQueriesColumns.eQueryIdColumn<ExternalUserEQuery>(
                params =>
                    this.urlBuilder
                        .esa()
                        .globalPopup()
                        .sponsorEQueryDetails(params.data.eQueryId)
                        .url()),
            this.externalUserEQueriesColumns.status,
            this.gridColumns.subjectColumn<ExternalUserEQuery>(
                params =>
                    this.urlBuilder
                        .esa()
                        .sponsor()
                        .study(selectedStudy)
                        .subjects(params.data.zcSubjectId)
                        .url(),
                data => SubjectTitleRenderer.renderSubjectNumberOrScreening(data)),
            this.gridColumns.accessionNumberColumn<ExternalUserEQuery>(
                params =>
                    this.urlBuilder
                        .esa()
                        .sponsor()
                        .study(selectedStudy)
                        .testResults(siteId)
                        .standardTestResults()
                        .url(),
                data => [data.accessionNumber],
            ),
            this.externalUserEQueriesColumns.visitCollectionDate,
            this.externalUserEQueriesColumns.visitName,
            this.externalUserEQueriesColumns.protocolVisitCode,
            this.eQueriesColumns.responders(),
            this.externalUserEQueriesColumns.responseTime
        ];
    }
}
